import { Component, Input, OnInit } from '@angular/core';
import { PublicidadTarjetas, Veterinaria } from 'src/core/veterinaria/veterinaria.types';

@Component({
  selector: 'app-card-info-vet',
  templateUrl: './card-info-vet.component.html',
  styleUrls: ['./card-info-vet.component.css']
})
export class CardInfoVetComponent implements OnInit {

  //@Input('veterinaria') veterinaria: Veterinaria;
  @Input('publicidad') publicidad: PublicidadTarjetas;


  ngOnInit(): void {
    /*this.veterinaria.horaApertura = this.formatTime(this.veterinaria.horaApertura);
    this.veterinaria.horaCierre = this.formatTime(this.veterinaria.horaCierre);*/
  }

  private formatTime(time: string): string {
    return time.substring(0, 5);
  }

}
